module.exports = __webpack_public_path__ + "img/11825378_L.d2ef4347.png";